import React from "react"

import * as courseTestimonialsStyles from "../styles/CourseTestimonials.module.css"

import { ChildSelector } from "../helpers/ChildSelector"

import WPImage, { DISPLAY_MODE } from "./_base/WPImage"

const COUNT_PER_PAGE = 3

export default function CourseTestimonials(props) {
  const { content } = props

  const [limit, setLimit] = React.useState(COUNT_PER_PAGE)

  const titleSection = ChildSelector.select(
    content,
    `intro-section-title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const cards = ChildSelector.select(
    content,
    `course-testimonial-card`,
    ChildSelector.SELECTOR_TYPE.ARRAY,
  ).map(card => ({
    holder: card,
    content: ChildSelector.select(
      card,
      `content`,
      ChildSelector.SELECTOR_TYPE.ARRAY,
    ).map(c => c.innerHTML),
    author: ChildSelector.select(
      card,
      `author`,
      ChildSelector.SELECTOR_TYPE.TEXT,
    ),
    authorPosition: ChildSelector.select(
      card,
      `position`,
      ChildSelector.SELECTOR_TYPE.TEXT,
    ),
    company: ChildSelector.select(
      card,
      `company`,
      ChildSelector.SELECTOR_TYPE.TEXT,
    ),
  }))

  return (
    <>
      <div
        className={`row ${props.className} ${courseTestimonialsStyles.wrapper}`}
      >
        <div className={`col-12 ${courseTestimonialsStyles.title}`}>
          <h1>{titleSection}</h1>
        </div>
        <div
          className={`row ${props.className} ${courseTestimonialsStyles.contentWrapper}`}
        >
          {cards &&
            cards.slice(0, Math.min(limit, cards.length - 1)).map((c, idx) => (
              <div className={`col-4 ${courseTestimonialsStyles.content}`}>
                <div className={`${courseTestimonialsStyles.card}`} key={idx}>
                  <div className={`row ${courseTestimonialsStyles.authorInfo}`}>
                    <div className={`col-3 ${courseTestimonialsStyles.media}`}>
                      <WPImage
                        holder={c.holder}
                        selector={`avatar`}
                        mode={DISPLAY_MODE.inline}
                        className={`${courseTestimonialsStyles.avatar}`}
                      />
                    </div>
                    <div
                      className={`col-9 ${courseTestimonialsStyles.authorInfo}`}
                    >
                      <h4 className={`${courseTestimonialsStyles.authorName}`}>
                        {c.author}
                      </h4>
                      <h5
                        className={`${courseTestimonialsStyles.authorPosition}`}
                      >
                        {c.authorPosition}
                      </h5>
                      <h6 className={`${courseTestimonialsStyles.companyName}`}>
                        {c.company}
                      </h6>
                    </div>
                  </div>
                  <div
                    className={`row ${courseTestimonialsStyles.testimonial}`}
                  >
                    <p className={`${courseTestimonialsStyles}`}>
                      {c.content &&
                        c.content.map(t => (
                          <span dangerouslySetInnerHTML={{ __html: t }} />
                        ))}
                    </p>
                  </div>
                </div>
              </div>
            ))}
        </div>
        <div className={`row ${courseTestimonialsStyles.more}`}>
          <div className={`col-12 ${courseTestimonialsStyles.moreBtn}`}>
            {limit < cards.length - 1 && (
              <a
                href="#!"
                className={`${courseTestimonialsStyles.loadMoreButton}`}
                onClick={evt => {
                  evt.preventDefault()
                  setLimit(limit + COUNT_PER_PAGE)
                }}
              >
                Load more
              </a>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
